export default class Config {

  static load(files, callback) {
    Config._files = files;
    if (!Array.isArray(files)) {
      Config._files = [files];
    }
    Config._loadNext(callback);
  }

  static _loadNext(callback) {
    if (Config._current < Config._files.length) {
      Config._dispatch(callback, Config.EVENT_LOAD_NEXT, { current: Config._current, total: Config._files.length });
      Config._load(callback);
    } else {
      Config._dispatch(callback, Config.EVENT_ALL_LOADED, { current: Config._current, total: Config._files.length });
    }
  }

  static _load(callback) {
    $.ajax({
      type: "GET",
      url: Config._getUrl(),
      success: Config._configLoaded.bind(Config, callback),
      error: Config._error.bind(Config, callback)
    });
  }
  static _getUrl() {
    let url = Config._files[Config._current];
    if (url.indexOf("?") >= 0) {
      url += "&rnd=" + (new Date()).getTime();
    } else {
      url += "?rnd=" + (new Date()).getTime();
    }
    return url;
  }

  static _toArrayObject(csv) {
    let ret = new Array();
    for (let x = 1; x < csv.length; x++) {
      let o = new Object();
      for (let y = 0; y < csv[0].length; y++) {
        o[csv[0][y]] = csv[x][y];
      }
      ret.push(o)
    }
    return ret;
  }

  static _configLoaded(callback, data) {
    let csv = jQuery.csv.toArrays(data);
    Config.cfgs.push(Config._toArrayObject(csv))
    Config._dispatch(callback, Config.EVENT_SINGLE_LOADED, { current: Config._current, total: Config._files.length });
    Config._current++;
    Config._loadNext(callback);
  }

  static _error(callback) {
    Config._dispatch(callback, Config.EVENT_LOAD_ERROR, { current: Config._current, total: Config._files.length });
  }

  static _dispatch(callback, type, data = null) {
    if (callback) {
      callback.call(null, { type: type, data: data });
    }
  }


}

Config._current = 0;
Config._files = [];

Config.EVENT_LOAD_NEXT = "eventLoadNext";
Config.EVENT_ALL_LOADED = "eventAllLoaded";
Config.EVENT_LOAD_ERROR = "eventLoadError";
Config.EVENT_SINGLE_LOADED = "eventSingleLoaded";

Config.cfgs = [];

